export const FORMATTED_DECIMALS = 2